import {API_URL, THEME_COLOR, numberWithCommas, CMS_URL} from "../constant"
import React, {useEffect, useState} from 'react';
import HeaderBack from "../layout/HeaderBack";
import "./Cart.css";
import {each, jQuery as $} from "jquery";
import { useLocalStorage } from "../useLocalStorage";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';

import banner1 from "../logo.svg"

import { useHistory } from "react-router";


const Cart = (props)=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [sumorder, setSumOrder] = useState(0);
    const [items, setItems] = useState([]);
    const [prices, setPrices] = useState([]);

    let prevwh = 0;
    let prevshipmethod = "";
    let prevshipdetail = 0;
    let history = useHistory();

    
    let Cardcontainer = (props) => {
        return (
            <div className="cart-card" key={`wh-${props.uniquekey}`}>
                <div className="cart-card-container">
                    <div className="cart-item-header">
                        <div className="cart-warehouse-name">
                            {props.warehousename}
                        </div>
                        <div className="cart-shipping-method">
                            {props.shippingmethod}
                        </div>
                    </div>
                    <hr />
                    {
                        props.items.map((value, index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.ImageName){
                                imgurl = `${CMS_URL}/images/upload/product/${value.ItemCode}/${value.ImageName}`;
                            }
                            return (
                                <div className="cart-item-detail" key={`${value.ID}-${index}`}>
                                    <div className="cart-item-checkbox">
                                        <label>
                                            <input type="checkbox" id={`checkbox-${value.ID}`} className={(value.PromoID !== 0) ? `promo-checkbox-${value.ID}` : ``} disabled={(value.Stock > 0) ? "" : "disabled"} onChange={() => CheckboxClick(value.ID, value.ItemUnitID)} defaultChecked={`${(value.IsChecked)? "checked": ""}`}/>
                                            <span></span>
                                        </label>
                                    </div>
                                    <div className="cart-item-image">
                                        <img src={imgurl}/>
                                    </div>
                                    <div className="cart-item-summary">
                                        <div className="cart-item-name">
                                            <span>{(value.PromoID !== 0) ? `[PROMO]` : ``} {value.ItemName}</span>
                                        </div>
                                        <div className="detail-promo-color">
                                            <span>Color: {value.ItemColor}</span>
                                        </div>
                                        <div className="detail-promo-size">
                                            <span>Size: {value.ItemSize}</span>
                                        </div>
                                        {
                                            (value.Stock <= 0)?
                                            (
                                                <div>
                                                    <span style={{"fontSize":"8pt", "color": "#FF1111"}}>Out of Stock</span>
                                                </div>       
                                            ):
                                            (
                                                <></>
                                            )
                                        }
                                        <div className="cart-item-price">
                                            Rp {numberWithCommas(value.ItemPrice)}
                                        </div>
                                        <div className="cart-qty-container">
                                            <div className="cart-qty-input">
                                                <div className="cart-button" onClick={()=> decrementQty(value.ID, value.ItemUnitID)}>
                                                    -
                                                </div>
                                                <div style={{width: "17%"}} >
                                                    <input type="text" data-itemid={value.ID} data-promoid={value.PromoID} defaultValue={value.ItemQty}  onChange={qtyChange} onKeyPress={qtyKeyPress} disabled={(value.PromoID !== 0) ? "disabled" : ""}  />
                                                </div>
                                                <div className="cart-button" onClick={()=> incrementQty(value.ID, value.ItemUnitID)}>
                                                    +
                                                </div>
                                            </div>
                                            <div>
                                                <i className="material-icons left delete-icon" onClick={()=>deleteItem(value.ID, value.ItemName, value.PromoID, value.PromoName)}>delete</i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }

    function submitHandler(){
        let titems = items.filter((value, index)=>{
            return value.IsChecked;
        })
        if(titems.length == 0){
            toast.error('No item selected!');
        }else{
            history.push('/checkout', { items: titems })
        }
    }

    function requestDelete(ID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();
        urlencoded.append("ID", ID);

        var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/cart`, requestOptions)
        .then(response => response.text())
        .catch(error => {});
    }

    function deleteItem(ID, Name, PromoID, PromoName){
        Swal.fire({
            title: "Are you sure?",
            text: `You won't be able to recovery ${(PromoID === 0)? Name: PromoName}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#ff3d00',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, remove it!`
        }).then( async (result)=>{
            if(result.isConfirmed){
                let titems = [...items];
                titems = titems.filter((value,index)=> {
                    return value.ID !== ID
                });
                recalculate(titems);
                setItems(titems)
                let response = await requestDelete(ID);
                response = JSON.parse(response);
                if(response.status == 200){
                    toast.success(response.message);
                }else{
                    toast.error(response.message);
                }
            }
        })

    }

    async function decrementQty(ID, ItemUnitID){
        let index = 0;
        let titems = [...items];
        let item = titems.filter((value,idx)=> {
            if(value.ID == ID && value.ItemUnitID == ItemUnitID)
                index = idx;
            return value.ID == ID && value.ItemUnitID == ItemUnitID
        })[0];
        if(item.PromoID === 0){
            item.ItemQty -= 1;
            if(item.ItemQty < 1){
                item.ItemQty = 1;
            }
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
        }
        recalculate();
    }

    function incrementQty(ID , ItemUnitID){
        let index = 0;
        let titems = [...items];
        let item = titems.filter((value,idx)=> {
            if(value.ID == ID && value.ItemUnitID == ItemUnitID)
                index = idx;
            return value.ID == ID && value.ItemUnitID == ItemUnitID
        })[0];
        if(item.PromoID === 0){
            item.ItemQty++;
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
            recalculate();
        }
        
    }


    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }
    
    function qtyChange(e){
        let index = 0;
        let titems = [...items];
        // let item = items[index];
        if(e.target.dataset.promoid == 0){
            let item = titems.filter((value,idx)=> {
                if(value.ID == e.target.dataset.itemid)
                    index = idx;
                return value.ID == e.target.dataset.itemid
            })[0];
            item.ItemQty = (!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value)
            if(item.ItemQty < 1){
                item.ItemQty = 1;
            }
            let itemprice = prices.filter((value,index)=>{
                return value.ItemUnitID == item.ItemUnitID
            })
            itemprice.forEach((value, index)=>{
                if(item.ItemQty >= value.Qty)
                    item.ItemPrice = value.Price
            })
            titems[index] = item;
            setItems(titems);
            recalculate();
        }
    }

    
    function CheckboxClick(ID, ItemUnitID){
        let index = -1;
        let titems = items;
        let item = titems.filter((value, idx) => {
            if(value.ID == ID && value.ItemUnitID == ItemUnitID)
                index = idx;
            return value.ID == ID && value.ItemUnitID == ItemUnitID
        })[0];
        
        if(item.PromoID !== 0){
            let cbs = document.getElementsByClassName("promo-checkbox-"+item.ID);
            each(cbs, function(){
                this.checked = (this.checked) ? 1: 0;
            })
            titems.map(element => {
                if(element.PromoID === item.PromoID){
                    element.IsChecked = (element.IsChecked) ? 0: 1;
                }
                return element
            })
        }else{
            let checkbox = document.getElementById("checkbox-"+ID)
            item.IsChecked = (checkbox.checked) ? 1: 0;
            titems[index] = item
        }
        // let sum = sumorder;
        // if(checkbox.checked){
        //     sum += item.ItemPrice * item.ItemQty;
        // }else{
        //     sum -= item.ItemPrice * item.ItemQty;
        // }
        setItems(titems);
        // setSumOrder(sum);
        recalculate();
    }

    function recalculate(titems=items){
        let sum = 0;
        titems.map((value, index)=>{
            if(value.IsChecked)
                sum += (value.ItemQty * value.ItemPrice);
        })
        setSumOrder(sum);
    }

    function getItemPrice(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/cart/price`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getItems(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/cart`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log(error));
    }

    useEffect(async ()=>{
        let response = await getItems();
        response = JSON.parse(response);
        if(response.status == 200){
            setItems(response.data)
        }
        else{
            toast.error(response.message);
        }
    },[])

    // useEffect(()=>{
    //     recalculate();
    // },[])

    useEffect(async ()=>{
        let response = await getItemPrice();
        if(response.status == 200){
            setPrices(response.data)
        }else{
            toast.error(response.message)
        }
    },[])

    function deselectAll(){
        let checkbox = document.getElementById("checkboxall");
        let titems = [...items];
        titems = titems.map((value, index)=>{
            value.IsChecked = (checkbox.checked) ? ((value.Stock > 0)?1:0) : 0
            return value;
        })
        setItems(titems);
        recalculate();
    }

    return (
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Cart"/>
            <div style={{width:"100%", padding: "10px 0", marginBottom:"30px"}}>

                {
                    items.map((value, index)=>{
                        if(prevwh != value.WarehouseDetail.WarehouseID || prevshipmethod != value.ShippingMethod || prevshipdetail != value.ShippingDetail.ShippingDetailID){
                            prevwh = value.WarehouseDetail.WarehouseID;
                            prevshipmethod = value.ShippingMethod;
                            prevshipdetail = value.ShippingDetail.ShippingDetailID;
                            return (
                                <Cardcontainer items={items.filter((value,index)=> value.WarehouseDetail.WarehouseID == prevwh && value.ShippingMethod == prevshipmethod && value.ShippingDetail.ShippingDetailID == prevshipdetail )} key={index} uniquekey={index} warehousename={value.WarehouseDetail.WarehouseName} shippingmethod= {value.ShippingMethod}/>
                            )
                        }
                    })
                }

            </div>
            <div className="cart-bottom">
                <div className="cart-footer">
                    <div style={{flex: "1"}}>
                        <label>
                            <input type="checkbox" id="checkboxall" onChange={()=>{ deselectAll() }}/>
                            <span>All</span>
                        </label>
                    </div>
                    <div className="" style={{flex:"2"}}>
                        <div className="cart-footer-sub">SubTotal</div><div className="cart-footer-price">Rp {numberWithCommas(sumorder)}</div>
                    </div>
                    <div style={{flex:1}}>
                        <button className={`btn ${THEME_COLOR}`} onClick={submitHandler}>CHECKOUT</button>
                    </div>
                </div>
            </div>
        </React.StrictMode>
    )
}

export default Cart;
